import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { BackArrowLink } from '../BackArrowLink/BackArrowLink';
import { LinkIntent } from '../Link/Link';

const messages = defineMessages({
  link: {
    id: 'src.components.RedeemBalanceCheckArrowLink.link',
    defaultMessage: '[[ Check balance & redeem ]]',
  },
});

export type Props = {
  className?: string;
  isExternal?: boolean;

  onClick?: () => void;
  redirect?: string;
  title?: string | JSX.Element;
};

export const RedeemBalanceCheckArrowLink = React.memo((props: Props) => {
  const {
    className,
    title,
    onClick,
    redirect,
    isExternal,
  } = props;

  return (
    <BackArrowLink
      onClick={onClick}
      redirect={redirect}
      isExternal={isExternal === undefined ? !!redirect : isExternal}
      title={title || <FormattedMessage {...messages.link} />}
      className={className}
      linkIntent={LinkIntent.quaternary}
    />
  );
});

RedeemBalanceCheckArrowLink.displayName = 'RedeemBalanceCheckArrowLink';
